// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSuccess_root__3Hfp2","fillColor":"IconSuccess_fillColor__Xr5pc"};